"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _colourconstantspartner = /*#__PURE__*/ _interop_require_default(require("../../colour-constants-partner"));
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
var _utils = require("@collinsonx/utils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  text-transform: uppercase;\n  font-weight: 600;\n  width: fit-content;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var _obj;
var partnerBrandBadgesColors = (_obj = {}, _obj[_utils.PartnerBrandStatus.RelationshipLive] = {
    bg: _colourconstantspartner.default["bg-green"],
    text: _colourconstantspartner.default["accent-green"]
}, _obj[_utils.PartnerBrandStatus.RelationshipEnded] = {
    bg: _colourconstantspartner.default["bg-surface-dark"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj[_utils.PartnerBrandStatus.Onboarding] = {
    bg: _colourconstantspartner.default["bg-amber"],
    text: _colourconstantspartner.default["accent-amber"]
}, // deprecated status fields remove when removed from backend
_obj[_utils.PartnerBrandStatus.Live] = {
    bg: _colourconstantspartner.default["white"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj[_utils.PartnerBrandStatus.Old] = {
    bg: _colourconstantspartner.default["white"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj);
var _obj1;
var outletBadgesColors = (_obj1 = {}, _obj1[_utils.OutletStatus.Active] = {
    bg: _colourconstantspartner.default["bg-green"],
    text: _colourconstantspartner.default["accent-green"]
}, _obj1[_utils.OutletStatus.Inactive] = {
    bg: _colourconstantspartner.default["bg-surface-dark"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj1[_utils.OutletStatus.StopSale] = {
    bg: _colourconstantspartner.default["bg-red"],
    text: _colourconstantspartner.default["accent-red"]
}, _obj1[_utils.OutletStatus.Onboarding] = {
    bg: _colourconstantspartner.default["bg-amber"],
    text: _colourconstantspartner.default["accent-amber"]
}, // deprecated status fields remove when removed from backend
_obj1[_utils.OutletStatus.Closed] = {
    bg: _colourconstantspartner.default["white"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj1[_utils.OutletStatus.Live] = {
    bg: _colourconstantspartner.default["white"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj1[_utils.OutletStatus.Old] = {
    bg: _colourconstantspartner.default["white"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj1);
var _obj2;
var productBadgesColors = (_obj2 = {}, _obj2[_utils.ProductStatus.Active] = {
    bg: _colourconstantspartner.default["bg-green"],
    text: _colourconstantspartner.default["accent-green"]
}, _obj2[_utils.ProductStatus.Inactive] = {
    bg: _colourconstantspartner.default["bg-surface-dark"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj2[_utils.ProductStatus.StopSale] = {
    bg: _colourconstantspartner.default["bg-red"],
    text: _colourconstantspartner.default["accent-red"]
}, // deprecated status fields remove when removed from backend
_obj2[_utils.ProductStatus.Open] = {
    bg: _colourconstantspartner.default["white"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj2[_utils.ProductStatus.Live] = {
    bg: _colourconstantspartner.default["white"],
    text: _colourconstantspartner.default["text-grey"]
}, _obj2);
var _obj3;
var workflowBrandBadgesColors = (_obj3 = {}, _obj3[_utils.OutletWorkflowStage.Published] = {
    bg: _colourconstantspartner.default["bg-green"],
    text: _colourconstantspartner.default["accent-green"]
}, _obj3[_utils.OutletWorkflowStage.Incomplete] = {
    bg: _colourconstantspartner.default["bg-red"],
    text: _colourconstantspartner.default["accent-red"]
}, _obj3[_utils.OutletWorkflowStage.Draft] = {
    bg: _colourconstantspartner.default["bg-amber"],
    text: _colourconstantspartner.default["accent-amber"]
}, _obj3);
var sizeCss = {
    large: "\n    font-size: 14px;\n    padding: 4px 10px 4px 10px;\n  ",
    small: "\n    font-size: 12px;\n    height: 19px;\n    padding: 2px 10px 2px 10px;\n  "
};
// Type guard to check if the type is from PartnerBrandStatus
function isPartnerBrandStatus(status) {
    return status === _utils.PartnerBrandStatus.RelationshipEnded || status === _utils.PartnerBrandStatus.RelationshipLive || status === _utils.PartnerBrandStatus.Onboarding;
}
// Type guard to check if the type is from ProductStatus
function isProductStatus(status) {
    return status === _utils.ProductStatus.Active || status === _utils.ProductStatus.Inactive || status === _utils.ProductStatus.StopSale;
}
function isWorkflowStatus(status) {
    return status === _utils.OutletWorkflowStage.Draft || status === _utils.OutletWorkflowStage.Incomplete || status === _utils.OutletWorkflowStage.Published;
}
var _StyledBox = (0, _styled.default)(_core.Box)(_templateObject(), function(param) {
    var type = param.type, size = param.size;
    var bg = "";
    var text = "";
    if (isPartnerBrandStatus(type)) {
        bg = partnerBrandBadgesColors[type].bg;
        text = partnerBrandBadgesColors[type].text;
    } else if (isProductStatus(type)) {
        bg = productBadgesColors[type].bg;
        text = productBadgesColors[type].text;
    } else if (isWorkflowStatus(type)) {
        bg = workflowBrandBadgesColors[type].bg;
        text = workflowBrandBadgesColors[type].text;
    } else {
        // It must belong to OutletStatus
        bg = outletBadgesColors[type].bg;
        text = outletBadgesColors[type].text;
    }
    return "\n      " + sizeCss[size] + "\n      background-color: " + bg + ";\n      color: " + text + ";\n    ";
});
// context https://v5.mantine.dev/styles/styled/#polymorphic-components
var StyledBox = (0, _core.createPolymorphicComponent)(_StyledBox);
var Badge = function(props) {
    var type = props.type, children = props.children;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(StyledBox, _extends({}, props, {
        children: children ? children : type
    }));
};
var _default = Badge;
